// ** Data transport: @salespark/api-client — resolves the SalesPark
// { status, data } contract natively (same transport standard as Flix).
import { withAuth } from "@salespark/api-client";

/******************************************************************
 * ##: purchasesApiClient
 * Builds the HTTP client for the learner "As minhas compras" page on
 * @salespark/api-client. Auth headers mirror the learner API contract
 * (x-email + Authorization token); a 401/403 reloads the page, same as
 * the Flix client.
 * @param {Object} authUser - auth.user (carries email + token)
 * @returns {Object} - configured api-client instance ({ status, data })
 * History:
 * 07-10-2026: Created
 ******************************************************************/
const purchasesApiClient = (authUser) =>
  withAuth({
    baseURL: process.env.REACT_APP_API_URL,
    authHeaders: { "x-email": authUser?.email, Authorization: authUser?.token },
    timeout: 60000,
    onAuthError: () => window.location.reload(),
  });

/******************************************************************
 * ##: purchasesList
 * Loads the authenticated learner's purchases (paid, matched by email),
 * each with a ready-to-open Checkout billing URL. Returns the SalesPark
 * contract directly from api-client.
 * @param {Object} authUser - auth.user (carries email + token)
 * @returns {Promise<{status:boolean,data:*}>} - SalesPark contract
 * History:
 * 07-10-2026: Created
 ******************************************************************/
export const purchasesList = (authUser) => purchasesApiClient(authUser).getMany("/users/purchases");

export default purchasesList;
